import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { PrinterService } from './printer.service';

export const Ng1PrinterModule = angular
  .module('control-room.shared.services.printer', [])
  .factory('crPrinterService', downgradeInjectable(PrinterService));
